import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateTime } from 'luxon';

@Component({
  selector: 'pop-date-picker-input',
  templateUrl: './date-picker-input.component.html',
  styleUrls: ['./date-picker-input.component.less']
})
export class DatePickerInputComponent {
  private _date: DateTime | Date;
  @Input()
  public get date() {
    return this._date;
  }
  public set date(value: DateTime | Date) {
    this._date = value;

    if (value instanceof DateTime) {
      value = value.toJSDate();
    }

    this.dateChange.emit(value);
  }

  @Output()
  public dateChange = new EventEmitter<Date>();

  @Input()
  public minDate?: Date;

  @Input()
  public maxDate?: Date;

  @Input()
  public isDisabled = false;

  @Input()
  public hideIcon = false;

  @Input()
  public openOnClick = false;

  @ViewChild('datePicker')
  public datePicker?: MatDatepicker<Date>;

  public onInputClick() {
    if (this.openOnClick) {
      this.datePicker?.open();
    }
  }
}
